import React from 'react';
import { Spinner } from 'V2/Shared/Spinner';
import styles from './styles.module.css';
import { CheckboxType } from './types';

export const Checkbox: React.FC<CheckboxType> = ({
  label,
  name,
  onChange,
  checked,
  disabled,
  isLoading,
}) => {
  return (
    <div className={styles.group}>
      <div className={styles.checkbox}>
        <input
          data-testid="checkbox"
          type="checkbox"
          id={`checkbox_${name}`}
          className={styles.input}
          checked={checked}
          disabled={disabled || isLoading}
          onChange={onChange}
        />
        <label htmlFor={`checkbox_${name}`} className={styles.label}>
          <div className={styles.icon}>
            {isLoading ? (
              <div className={styles.spinnerBox}>
                <Spinner variant="blue" />
              </div>
            ) : (
              <>
                <div className={styles.box} />
                <div className={styles.check} />
              </>
            )}
          </div>
          {label}
        </label>
      </div>
    </div>
  );
};
